import { ICalendarAuth } from '../entities/calendar_auth';
import { BaseOrganizationEndpoints } from './base';
import { ResponseWithStatus } from './response/response_with_status';

export class CalendarAuth extends BaseOrganizationEndpoints {
  async getAvailablePermissions(
    provider: 'microsoft'
  ): Promise<ResponseWithStatus<ICalendarAuth>> {
    return this.requestWithStatus<ICalendarAuth>(
      'GET',
      `/v1/calendars/authorization/${provider}`
    );
  }

  async getMicrosoftPermissions() {
    return this.getAvailablePermissions('microsoft');
  }
}
